// utils/arrays.js
//
// Small array helpers shared by services. `chunk` splits a list for
// Firestore `in` queries (30 values per query).

export const FIRESTORE_IN_LIMIT = 30;

export function chunk(arr, size) {
  const list = Array.isArray(arr) ? arr : [];
  const n = Math.max(1, Math.floor(size) || 1);
  const out = [];
  for (let i = 0; i < list.length; i += n) out.push(list.slice(i, i + n));
  return out;
}
